//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The reset password request model
* 
* @param emailAddress The user email
* @param locale The locale from user settings or system default
* @param resetUrlTemplate The url template for the reset view, should contain a '{HASH}'-placeholder
*/
@Serializable

data class ResetPasswordRequest (


      /* The user email */
    @SerialName(value = "emailAddress") @Required val emailAddress: kotlin.String,


      /* The locale from user settings or system default */
    @SerialName(value = "locale") @Required val locale: kotlin.String,


      /* The url template for the reset view, should contain a '{HASH}'-placeholder */
    @SerialName(value = "resetUrlTemplate") @Required val resetUrlTemplate: kotlin.String


) {




  }

